import {FieldHandler} from "./fieldHandler";
import UrlHelpers from "./url";
import {Notification} from "./notification";
import {i18n} from "./i18n";
import {setContextActions} from "./contextActions";
import {ErrorHandler} from "./errorHandler";

export class PermissionManagement{
    private _dapi: Dapi = (<any>window).dapi;
    private _dux = (<any>window).dux;
    private _i18n: i18n = new i18n();

    constructor(){
        this._dapi.addResourceEventListener('changed',this._dapi_event);
        this._dapi.addResourceEventListener('deleted',this._dapi_event);
        (<HTMLAnchorElement>document.getElementById("btnAdd")).addEventListener("click", this.btnAdd_Click);

        this.setRemoveBtnEvents();
        setContextActions(this._dapi, this._i18n, null);
    }

    public setRemoveBtnEvents = () => {
        let removeBtns = document.getElementsByName("removePermission");
        for (let i = 0; i < removeBtns.length; i++){
            removeBtns[i].addEventListener("click", this.btnDelete_Click);
        }
    };

    public btnAdd_Click = () => {
        FieldHandler.clearFieldError("usermail");
        let data : PermissionDto = this._getValues();
        if (data !== null){
            let url = UrlHelpers.getLinkRelHref("self");
            let xhr = new XMLHttpRequest();
            xhr.open('PUT', url);
            xhr.setRequestHeader('accept','application/json');
            xhr.onload = () => {
                if (xhr.status === 200){
                    this._dapi.dispatchResourceEvent({
                        name: "changed",
                        uri: url
                    });
                    let title = this._i18n.getTranslation('permissionmgnt_notification_useradded_title'); //"Benutzer hinzugefügt";
                    let msg = i18n.replaceTranslationPlaceholder(this._i18n.getTranslation('permissionmgnt_notification_useradded_msg'), "{user}",data.mail); //"Benutzer '" + data.mail + "' konnte erfolgreich berechtigt werden.";
                    Notification.showSuccessNotification(title, msg);
                    FieldHandler.setFieldValue("usermail","");
                } else if (xhr.status === 422) {
                    let title = this._i18n.getTranslation('permissionmgnt_notification_useralreadyexist_title');
                    let msg = i18n.replaceTranslationPlaceholder(this._i18n.getTranslation('permissionmgnt_notification_useralreadyexist_msg'), "{user}", data.mail); //"Berechtigung für Benutzer '" + data.mail + "' existiert bereits.";
                    Notification.showSuccessNotification(title, msg);
                    FieldHandler.setFieldValue("usermail","");
                } else if (xhr.status === 400) {
                    console.warn(xhr.responseText);
                    let error = ErrorHandler.parseError(xhr.responseText);
                    if(error.description.trim() === "E-Mail is invalid"){
                        let title = this._i18n.getTranslation('permissionmgnt_notification_invalidmail_title');
                        let msg = this._i18n.getTranslation('permissionmgnt_notification_invalidmail_msg');
                        FieldHandler.setFieldError("usermail", msg);
                        Notification.showErrorNotification(title, msg);
                    } else {
                        let title = this._i18n.getTranslation('permissionmgnt_notification_failedrequest_title');
                        let msg = this._i18n.getTranslation('permissionmgnt_notification_failedrequest_msg');
                        Notification.showErrorNotification(title, msg);
                    }
                } else {
                    let title = this._i18n.getTranslation('permissionmgnt_notification_internalError_title');
                    let msg = this._i18n.getTranslation('permissionmgnt_notification_internalError_msg');
                    Notification.showErrorNotification(title, msg);
                    console.error(xhr.responseText);
                }
            };
            xhr.send(JSON.stringify(data));
        } else {
            console.warn("User field was empty!");
        }
    };

    public btnDelete_Click = (e:any) => {
        let current = e.currentTarget;
        let user = current.dataset["mail"];
        let role = current.dataset["role"];
        let msg = i18n.replaceTranslationPlaceholder(this._i18n.getTranslation('permissionmgnt_dialog_deleteuser_msg'),"{user}", user);
        this._dux.query.notifier(msg, {
           title: this._i18n.getTranslation('permissionmgnt_dialog_deleteuser_title'),
           showClose: true,
           submit: this._i18n.getTranslation('permissionmgnt_dialog_deleteuser_btn_submit_title'),
           priority: 'warning',
           callback: () => {
               this._removePermission(user, role);
           }
        });
    };

    private _removePermission = (currentMail: string, currentRole: string) => {
        let dto = {
            mail: currentMail,
            role: currentRole
        };
        let url = UrlHelpers.getLinkRelHref('self');
        let xhr = new XMLHttpRequest();
        xhr.open('DELETE', url);
        xhr.setRequestHeader('accept','application/json');
        xhr.onload = () => {
            if(xhr.status === 204){
                console.log('Remove permission successfully');
                this._dapi.dispatchResourceEvent({
                    name:"deleted",
                    uri: url
                });
                let title = this._i18n.getTranslation('permissionmgnt_notifcation_removepermission_success_title');
                let msg = i18n.replaceTranslationPlaceholder(this._i18n.getTranslation('permissionmgnt_notifcation_removepermission_success_msg'), "{user}", currentMail);
                Notification.showSuccessNotification(title, msg);
            } else {
                console.error(xhr.responseText);
                let title = this._i18n.getTranslation('permissionmgnt_notifcation_removepermission_failed_title');
                let msg = i18n.replaceTranslationPlaceholder(this._i18n.getTranslation('permissionmgnt_notifcation_removepermission_failed_msg'),"{user}",currentMail);
                Notification.showErrorNotification(title, msg);
            }
        };
        xhr.send(JSON.stringify(dto));
    };

    private _getValues = () : PermissionDto => {
        let retVal = {
            isCurrent: false,
            // role: FieldHandler.getFieldValue("permissionrole"),
            mail: FieldHandler.getFieldValue("usermail")
        };
        let error:boolean = false;
        if (retVal.mail === "") {
            FieldHandler.setFieldError("usermail", this._i18n.getTranslation('permissionmgnt_requiredfield_user_empty'));
            error = true;
        }
        if (error) {
            return null;
        }
        return retVal;
    };

    private _dapi_event = (resourceEvent: IResourceEvent) => {
        let url = UrlHelpers.getLinkRelHref('refresh');
        if(resourceEvent.uri === UrlHelpers.getLinkRelHref('self')) {
            let xhr = new XMLHttpRequest();
            let e = document.getElementById("permissionTableContent");
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    e.innerHTML = xhr.responseText;
                    this.setRemoveBtnEvents();
                }
            };
            xhr.open('GET', url, true);
            try{
                xhr.send();
            }catch(err){
                console.error(err);
            }
        }
    }
}

export interface PermissionDto {
    mail        : string;
    // role        : string;
    isCurrent   : boolean;
}